import { MasterData } from '../shared/index';

export const SERVER_URL = window && window['BASE_API_URL'] ? window['BASE_API_URL'] :   '';
/**
 * cek ke konfig google console
 */
export const GOOGLE_ID = "394744634166-0im444hl1t8mncdudf707ev93qo4uo7a.apps.googleusercontent.com";

export const GMAP_API_KEY = 'AIzaSyAwKQXrpCCyjwljuwmbdhvxaeQ5dZi5DF8';

export const STRIPEKEY = "pk_live_4eiWAVvUlMrET089jbpVER0E";
/**
 * cek ke konfigruasi login FB
 */
export const FACEBOOK_API_ID: string = "471348066377828";

export const LOCAL_STORAGE_SEASON: string = "BHAM.ID_";
/**
 * key untuk current hotel filter
 */
export const LOCAL_STORAGE_KEY_HOTEL_FILTER: string = 'bali-hotels::current_filter';
/**
 * untuk key external filter
 */
export const LOCAL_STORAGE_KEY_HOTEL_EXT_FILTER: string = 'bali-hotels::ext_filter';
export const TRIPADVISOR = {
    // WidgetEmbed : "//www.tripadvisor.com/WidgetEmbed-cdspropertydetail?display=true&partnerId=be9d0fddea2a4c13b648c62faf3234f8&lang=en&locationId="
    WidgetEmbed: "//www.tripadvisor.com/WidgetEmbed-cdspropertydetail?display=true&partnerId=F9EE60EBA0E745229E52270CF5A94430&lang=en&locationId="
};

export function GetImageUrl() {
    return "/uploads";
}

export const STATICLANGUAGEURL = "/assets/static-content";
export const STATICREVIEWURL = "/assets/reviews";
export const STATICLANGUAGEWINDOW = "StaticLanguage";

export const HOME_SLIDE_TIME = 2000;

export const KEY_DEFAULT_SEARCH_COUNTRY_CODE: string = 'DEFAULT_SEARCH_COUNTRY';
export const KEY_DEFAULT_SEARCH_DEST_CODE: string = 'DEFAULT_SEARCH_DEST';

export const LOCAL_STORAGE_KEY_WISHLIST: string = 'BHAM_WISLISH';

export const SESSION_STORAGE_BOOKING: string = "BHAM_BOOKING";

export const SESSION_STORAGE_POPUP_BANNER: string = "SESSION_STORAGE_POPUP_BANNER";
export const SESSION_STORAGE_POPUP_BANNER_TIME_SHOW: number = 10000;

export const BHAM_STORAGE_WISHLIST: string = "BHAM_Wishlist_id";
export const BHAM_STORAGE_AFFILIATE: string = "BHAM_affiliate_id"; 

// export const SESSION_STORAGE_AVAILABILITY_FILTER: string = "BHAM_AVAILABILITY_FILTER";

// export const SESSION_STORAGE_AVAILABILITY_LEFT_FILTER: string = "BHAM_AVAILABILITY_LEFT_FILTER"; 
/**
 * key current request(di session storage). di isi pada saat tiap tekan search
 */
export const SESSION_STORAGE_HOTEL_FILTER_CURRENT_REQ_KEY: string = 'current_hotel_req_key';
/**
 * key untuk filter current. di isi dengan 
 */
// export const SESSION_STORAGE_HOTEL_FILTER_CURRENT_KEY: string = 'current_hotel_search';
/**
 * key current booking checkout data
 */
// export const SESSION_STORAGE_CURRENT_BOOKING_CHECKOUT_DATA: string = 'bham_current_booking_checkout_data';
export const SESSION_STORAGE_SATTLEMENT_BOOKING_DATA: string = 'BHAM_SESSION_STORAGE_SATTLEMENT_BOOKING_DATA';

export const SEARCH_TYPE = "local"; // isi google jika pake aponya google 
import { isNull } from '../utils/index';
export const COMPANY_INFO: MasterData.CompanyInfo = {
    "name": "Bali Hotels And More",
    "logo": "",
    "icon": "",
    "address": "",
    "email": "info@theoerp.com",
    "website": "http://theoerp.com",
    "phone": "+62 361 300125"
};
export const SOCMED_TWTR: MasterData.SocialMedia = {
    "name": "Twitter",
    "data-placement": "bottom",
    "data-original-title": "Twitter",
    "className": "social-twitter tooltips",
    "link": "http://www.twitter.com",
    "icon": "social-twitter",
    "color": "blue"
};
export const SOCMED_FB: MasterData.SocialMedia = {
    "name": "Facebook",
    "data-placement": "bottom",
    "data-original-title": "Facebook",
    "className": "social-facebook tooltips",
    "link": "http://www.facebook.com",
    "icon": "social-facebook",
    "color": "blue"
};
export const SOCMED_GPLUS: MasterData.SocialMedia = {
    "name": "Google+",
    "data-placement": "bottom",
    "data-original-title": "Google",
    "className": "social-google tooltips",
    "link": "http://www.google.com",
    "icon": "social-google",
    "color": "blue"
};
export const SOCMED_YOUTUBE: MasterData.SocialMedia = {
    "name": "YouTube",
    "data-placement": "bottom",
    "data-original-title": "YouTube",
    "className": "social-youtube tooltips",
    "link": "http://www.youtube.com",
    "icon": "social-youtube",
    "color": "blue"
};
/*
export const COMPANY_SEO: SecurityData.SEOContent = {
    "title": 'Bali Villas And More',
    "description": "Best Hotels booking in bali",
    "keyword": 'bali-hotels'
};
*/

export const newI18n = function (key: string , defaultText: string ): string  {
    let dataLang = window[STATICLANGUAGEWINDOW]; 
    let text = !isNull(dataLang) && !isNull(dataLang[key]) ? dataLang[key] : defaultText;
    return text; 
};

export const getFirstBrowserLanguage = function (): string {
    // return 'KOR' ; 
    let rtvl: any = null;
    var nav = window.navigator,
        browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
        i,
        language;

    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
        for (i = 0; i < nav.languages.length; i++) {
            language = nav.languages[i];
            if (language && language.length) {
                if (language === 'id') {
                    return 'IND';
                } else {
                    return 'ENG';
                }

            }
        }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
        language = nav[browserLanguagePropertyKeys[i]];
        if (language && language.length) {
            if (language === 'id') {
                return 'IND';
            } else {
                return 'ENG';
            }
        }
    }
    return rtvl;

};
export function getHotelSlug(name: string, code: number) {
    let hotelSlug = `${name.split(' ').join('-').toLowerCase()}-${code}`;
    hotelSlug = hotelSlug.replace('---', '-');
    hotelSlug = hotelSlug.replace('.', '');
    hotelSlug = hotelSlug.replace('(', '');
    hotelSlug = hotelSlug.replace(')', '');
    hotelSlug = hotelSlug.replace('\'', '-');
    hotelSlug = hotelSlug.replace('/', '-');
    hotelSlug = hotelSlug.replace('š', 's');
    hotelSlug = hotelSlug.replace('Ð', 'Dj');
    hotelSlug = hotelSlug.replace('ž', 'z');
    hotelSlug = hotelSlug.replace('Þ', 'B');
    hotelSlug = hotelSlug.replace('ß', 'Ss');
    hotelSlug = hotelSlug.replace('à', 'a');
    hotelSlug = hotelSlug.replace('á', 'a');
    hotelSlug = hotelSlug.replace('â', 'a');
    hotelSlug = hotelSlug.replace('ã', 'a');
    hotelSlug = hotelSlug.replace('ä', 'a');
    hotelSlug = hotelSlug.replace('å', 'a');
    hotelSlug = hotelSlug.replace('æ', 'a');
    hotelSlug = hotelSlug.replace('ç', 'c');
    hotelSlug = hotelSlug.replace('è', 'e');
    hotelSlug = hotelSlug.replace('é', 'e');
    hotelSlug = hotelSlug.replace('ê', 'e');
    hotelSlug = hotelSlug.replace('ë', 'e');
    hotelSlug = hotelSlug.replace('ì', 'i');
    hotelSlug = hotelSlug.replace('í', 'i');
    hotelSlug = hotelSlug.replace('î', 'i');
    hotelSlug = hotelSlug.replace('ï', 'i');
    hotelSlug = hotelSlug.replace('ð', 'o');
    hotelSlug = hotelSlug.replace('ñ', 'n');
    hotelSlug = hotelSlug.replace('ò', 'o');
    hotelSlug = hotelSlug.replace('ó', 'o');
    hotelSlug = hotelSlug.replace('ô', 'o');
    hotelSlug = hotelSlug.replace('õ', 'o');
    hotelSlug = hotelSlug.replace('ö', 'o');
    hotelSlug = hotelSlug.replace('ø', 'o');
    hotelSlug = hotelSlug.replace('ù', 'u');
    hotelSlug = hotelSlug.replace('ú', 'u');
    hotelSlug = hotelSlug.replace('û', 'u');
    hotelSlug = hotelSlug.replace('ý', 'y');
    hotelSlug = hotelSlug.replace('ý', 'y');
    hotelSlug = hotelSlug.replace('þ', 'b');
    hotelSlug = hotelSlug.replace('ÿ', 'y');
    hotelSlug = hotelSlug.replace('ƒ', 'f');
    hotelSlug = hotelSlug.replace('œ', 'oe');
    hotelSlug = hotelSlug.replace('€', 'euro');
    hotelSlug = hotelSlug.replace('$', 'dollars');
    hotelSlug = hotelSlug.replace('£', '');
    hotelSlug = hotelSlug.replace(',', '');
    hotelSlug = hotelSlug.replace('&', 'and');
    hotelSlug = hotelSlug.replace(' ', '-');
    hotelSlug = hotelSlug.replace('--', '-');
    
    return hotelSlug;
}

export function scrollToTop() {
    window.scrollTo(0 , 0 ) ;
    /*var sc = window.setInterval(
        () => {
            var pos = window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - 50);
            } else {
                window.clearInterval(sc);
            }
        }
        ,
        5);*/
    
}

export function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

export class FormatterUtils {

    /**
     * format duit
     * @param value number yang perlu di format
     * @param useComaDecimalSeparator true  berarti pemisah decimal = ,(versi Indonesia)
     * @param remainedDecimal berapa di sisikan di belakang koma
     */
    formatMoney(value: number, currencyCode: string, showCurrencyCode: boolean, useComaDecimalSeparator?: boolean, remainedDecimal?: number): string {
        let belakang = '';
        if (currencyCode === 'IDR') {
            value = value / 1000;
            belakang = 'K';
        }
        if (value === null || typeof value === "undefined") {
            return "";
        }
        let minus = false;
        if (value < 0) {
            minus = true;
            value = value * -1;
        }
        let blkKoma: number = isNull(remainedDecimal) ? 2 : remainedDecimal!;
        let useKoma: boolean = false; // isNull(useComaDecimalSeparator) ? true : useComaDecimalSeparator!;
        let arr: string[] = (value + '').split('.');
        let dpnKoma: number = parseFloat(arr[0]);
        let bagi = '';
        if (arr.length > 1) {
            let blkAsli = arr[1];
            for (let i = 0; i < blkAsli.length; i++) {
                if (blkAsli.substring(i, 1) === '0') {
                    bagi += '0';
                } else {
                    break;
                }
            }
        }

        let blk: number = arr.length > 1 ? parseFloat(arr[1]) : 0;
        let curCode = '';
        if (showCurrencyCode === true) {
            curCode = currencyCode;
        }
        let strDepanKoma: string = this.formatDepanKoma(dpnKoma, useKoma ? '.' : ',');
        let strBlk: string = this.formatBelakangKoma(blk, blkKoma, bagi);
        if (strBlk.length === 0) {
            return curCode + ' ' + strDepanKoma  + belakang;
        }
        
        return curCode + ' ' + (minus ? '-' : '') + strDepanKoma + (useKoma ? ',' : '.') + strBlk + belakang;
    }

    private formatBelakangKoma(blkKoma: number, keeped: number, bagi: string): string {
        if (blkKoma === 0) {
            return '';
        }
        let rtvl: string = bagi + blkKoma + '';
        if (keeped > rtvl.length) {
            return rtvl;
        }
        return rtvl.substr(0, keeped);
    }

    private formatDepanKoma(dpnKoma: number, separator: string) {
        if (dpnKoma === 0) {
            return "0";
        }
        let strN: string = dpnKoma + '';
        let arr: string[] = [];
        while (strN.length > 3) {
            let pjg: number = strN.length;
            arr.push(strN.substr(pjg - 3));
            strN = strN.substr(0, pjg - 3);
        }
        arr.push(strN);
        arr = arr.reverse();
        return arr.join(separator);
    }

} 



// WEBPACK FOOTER //
// ./src/core/Const.ts